var React = require('react');

function LogoInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#E6E5E1","d":"m13.535 24.926 1.567-4.578-8.57 4.578zM77.44 24.926h5.324V6.289l-5.325 3.75zM85.835 4.125v20.8h5.358V.353zM59.568 24.926h5.324V.352l-5.324 5.27zM50.894 2.305h-3.91c2.718.953 4.682 3.648 4.682 6.832s-1.96 5.879-4.683 6.832h3.91c3.587 0 6.495-3.059 6.495-6.832 0-3.774-2.908-6.832-6.494-6.832M66.89 11.23l-1.545 1.23c2.544 0 3.77 1.536 3.77 3.692v8.774h5.324V14.94c-.004-4.312-4.311-6.296-7.549-3.71M6.082 2.305H0v22.62h6.082zM46.538 2.305h-6.082v22.62h6.082zM20.783 3.71 18.96 9.048l2.532 6.918h-4.894l-.39 1.14c3.461 0 6.524 2.266 7.765 5.649l.798 2.172h6.557L22.94 1.992zM80.098 6.07c1.593 0 2.885-1.359 2.885-3.035S81.691 0 80.098 0c-1.594 0-2.885 1.359-2.885 3.035s1.291 3.035 2.885 3.035"}));
}

LogoInline.defaultProps = {"width":"92","height":"25","fill":"none","viewBox":"0 0 92 25"};

module.exports = LogoInline;

LogoInline.default = LogoInline;
